import { useState } from "react";

import { HostConfigurationEditForm } from "src/app/features/HostConfiguration/components/forms/HostConfigurationEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const HostConfigurationEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.HOST_CONFIGURATIONS, "canWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.hostConfigurationsEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.HOST_CONFIGURATIONS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <HostConfigurationEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
